<script lang="ts" setup>
import ErrorPage from '../ErrorPage/ErrorPage.vue';
</script>

<template>
  <ErrorPage
    title="401"
    sub-title="Je hebt geen toegang tot deze pagina"
    description="Deze functionaliteit is niet beschikbaar..."
  />
</template>
